import React from 'react'
import {Route} from 'react-router-dom'

import AssetModelListPage from './pages/AssetModelListPage/AssetModelListPage';
import { ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL, ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_EDIT, ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_CREATE } from '../../../../../../../../constants/route-constant';
import AssetModelChangePage from './pages/AssetModelChangePage/AssetModelChangePage';

class AssetModelPage extends React.Component {
  render () {
    return (
      <div
        style={{
          height: '100%',
          width: '100%'
        }}
      >
        <Route
          exact
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL}
          render={props => (<AssetModelListPage {...props} />)}
        />

        <Route
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_CREATE}
          render={props => (<AssetModelChangePage {...props} />)}
        />

        <Route
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_EDIT}
          render={props => (<AssetModelChangePage {...props} />)}
        />
      </div>
    )
  }
}

export default AssetModelPage
